module.exports = __webpack_public_path__ + "01_short_beige.01f8febd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/01_short_beige.png
// module id = GmmA
// module chunks = 0